import { Editor } from '@tiptap/react'

export interface MergeFieldData {
    mergeFields: Array<{ mergeKey: string }>
    mergeFieldDelimiters: {
        open: string
        close: string
    }
}

export const makeMergeFieldInserter = (editor: Editor | null | undefined) => {
    return (field: string) => {
        editor
            ?.chain()
            .insertContent(
                `<span data-id="${field}" data-type="mention"></span>`
            )
            .run()
    }
}

export const makeMergeFieldRemover = (data: MergeFieldData | undefined) => {
    return (message: string) => {
        const frontBrackets = message.replace(
            /<span class="mention" data-type="mention" data-id="/g,
            data?.mergeFieldDelimiters.open || '{{'
        )
        const bothBrackets = frontBrackets.replace(
            /">@[\w]*<\/span>/g,
            data?.mergeFieldDelimiters.close || '}}'
        )
        return bothBrackets
    }
}

export const makeMergeFieldExtractor = (data: MergeFieldData | undefined) => {
    return (message: string) => {
        let match: RegExpExecArray | null
        const matches = new Map()
        const allowedMergeFields = data?.mergeFields.map(
            (field) => field.mergeKey
        )
        if (!allowedMergeFields || allowedMergeFields.length === 0) return []
        const regex = new RegExp(`{{(${allowedMergeFields.join('|')})}}`, 'g')
        while ((match = regex.exec(message))) {
            matches.set(match[0], true)
        }
        return Array.from(matches.keys())
    }
}
